import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import StarshipChapter from './StarshipChapter.vue';
import StarshipsVentures from '@/pages/Starships/StarshipsVentures.vue';
let StarshipVentures = class StarshipVentures extends Vue {
};
StarshipVentures = __decorate([
    Component({
        components: {
            StarshipChapter,
            StarshipsVentures
        }
    })
], StarshipVentures);
export default StarshipVentures;
